import { render } from "./AdminFormElementButtonAdd.vue?vue&type=template&id=a17ec136"
import script from "./AdminFormElementButtonAdd.vue?vue&type=script&lang=js"
export * from "./AdminFormElementButtonAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__